import { NavBar } from "@/components/navigation/nav-bar";
import { SEO } from "@/components/seo/SEO";
import { getOrganizationStructuredData, getWebSiteStructuredData } from "@/utils/structured-data";
import { Home } from "@/sections/home";
import { TrustBar } from "@/sections/trust-bar";
import { Comparison } from "@/sections/comparison";
import { MeetWorkers } from "@/sections/meet-workers";
import { Platform } from "@/sections/platform";
import { CaseStudies } from "@/sections/use-cases";
import { WhatYouGet } from "@/sections/what-you-get";
import { Pricing } from "@/sections/pricing";
import { HowIWork } from "@/sections/how-i-work";
import { Identity } from "@/sections/identity";
import { Footer } from "@/sections/footer";
import { EmailCapturePopup } from "@/components/lead-capture/email-capture-popup";
import { useSectionTracker } from "@/hooks/useSectionTracker";

export function HomePage() {
  useSectionTracker();

  // Combine structured data
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      getOrganizationStructuredData(),
      getWebSiteStructuredData()
    ]
  };

  return (
    <>
      <SEO
        title="Agency of Poly — Hire Your Digital Workforce | AI Workers, Teams & Departments"
        description="Hire AI workers, teams, and departments for real business functions. Monthly salary, included work budget, output guarantees tied to your KPIs. Try one task with credits — no commitment."
        url="https://agencyofpoly.com"
        jsonLd={structuredData}
      />
      <div className="flex min-h-svh flex-col">
        <NavBar />
        <main className="w-full max-w-[1550px] mx-auto">
          <Home />
          <TrustBar />
          <Comparison />
          <MeetWorkers />
          <Platform />
          <CaseStudies />
          <WhatYouGet />
          <Pricing />
          <HowIWork />
          <Identity />
          <Footer />
        </main>
        <EmailCapturePopup />
      </div>
    </>
  );
}